import { defineAbility } from '@casl/ability';

/**
 * Define user abilities based on their stored role.
 *
 * Case-insensitive: callers may pass 'ADMIN' or 'admin' interchangeably.
 */
export default function defineAbilityFor(_userRole: string | null | undefined) {
  return defineAbility((can) => {
    // Authenticated users always reach Home.
    can('visit', ABILITY_PAGES.HOME);
  });
}

export const enum ABILITY_PAGES {
  HOME = 'home',
}

export const enum ABILITY_TYPES {
  VISIT = 'visit',
}
